const timelineExpanded = (state = false, action) => {
  switch (action.type) {
    case 'TOGGLE_EXPANDED_TIMELINE':
      return action.toggleValue;
    default:
      return state;
  }
};

export default timelineExpanded;
